import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { AlertService, AlertType } from "@app/shared/alert";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class ResponseInterceptorService implements HttpInterceptor {
  private requiredHandlerError = false;

  constructor(private injector: Injector, private alertService: AlertService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.requiredHandlerError = req.headers.get("error-handler") ? true : false;

    return next.handle(req).pipe(
      tap({
        next: (event) => {
          return event;
        },
        error: (error) => {
          if (!this.requiredHandlerError) {
            return;
          }
          // TODO: implements logic for show or log the errors (alets, notify, logfile)
          // Alert Exambple
          // this.showErrorAlert(error);
          console.error(error);
        },
      })
    );
  }

  private showErrorAlert(error) {
    if (error.status === 500) {
      this.alertService.open(error.error.message || "Server error", AlertType.Error, true);
      return;
    }
    if (error.status === 502) {
      this.alertService.open(error.error.message || "Bad Gateway", AlertType.Error, true);
      return;
    }
    this.alertService.open(error.error.message, AlertType.Error, true);
  }
}
